export function request() {
    return {
        type: 'BONUSES_REQUEST'
    };
}

export function error(errors) {
    return {
        type: 'BONUSES_ERROR',
        errors
    };
}

export function finish(bonuses) {
    return {
        type: 'BONUSES_FINISH',
        bonuses
    };
}
